import React from "react";
// nodejs library that concatenates classes
// @material-ui/core components

import { List, ListItem, Box } from "@mui/material";

// core components
import Header from "../../../components/Header/Header.js";
import Button from "../../../components/CustomButtons/Button.js";

import headersStyle from "../../../assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { getSxStyle } from "../../../utils/getSxStyle.js";

export default function HeaderSection({ ...rest }) {

    return (
        // we've set the className to cd-section so we can make smooth scroll to it{/*...rest*/}
        <div className="c" >
            {/*<div className={classes.sectionBlank} id="blanksection" />*/}

            {/* HEADER 2 START  .MuiAppBar-colorPrimary */}
            <div>
                <Header
                    absolute
                    brand="Smart Part"
                    color="transparent"

                    links={
                        <Box sx={(theme) => getSxStyle(theme, headersStyle, ['collapse'])}>
                            <List sx={(theme) => getSxStyle(theme, headersStyle, ['list', 'mlAuto'])}>
                                <ListItem sx={(theme) => getSxStyle(theme, headersStyle, ['listItem'])}>
                                    <Button
                                        href="/landing"
                                        sx={(theme) => getSxStyle(theme, headersStyle, ['navLink'])}
                                        //onClick={e => e.preventDefault()}
                                        color="transparent"
                                    >
                                        Home
                                    </Button>
                                </ListItem>
                                {/*<ListItem className={classes.listItem}>*/}
                                {/*  <Button*/}
                                {/*    href="#pablo"*/}
                                {/*    className={classes.navLink}*/}
                                {/*    onClick={e => e.preventDefault()}*/}
                                {/*    color="transparent"*/}
                                {/*  >*/}
                                {/*    About us*/}
                                {/*  </Button>*/}
                                {/*</ListItem>*/}
                                {/*<ListItem className={classes.listItem}>*/}
                                {/*  <Button*/}
                                {/*    href="#pablo"*/}
                                {/*    className={classes.navLink}*/}
                                {/*    onClick={e => e.preventDefault()}*/}
                                {/*    color="transparent"*/}
                                {/*  >*/}
                                {/*    Products*/}
                                {/*  </Button>*/}
                                {/*</ListItem>*/}
                                <ListItem sx={(theme) => getSxStyle(theme, headersStyle, ['listItem'])}>
                                    <Button
                                        href="/support"
                                        sx={(theme) => getSxStyle(theme, headersStyle, ['navLink'])}
                                        //onClick={e => e.preventDefault()}
                                        color="transparent"
                                    >
                                        Podrška
                                    </Button>
                                </ListItem>
                                <ListItem sx={(theme) => getSxStyle(theme, headersStyle, ['listItem'])}>
                                    <Button
                                        href="/signin"
                                        sx={(theme) => getSxStyle(theme, headersStyle, ['navLink'])}
                                        //onClick={e => e.preventDefault()}
                                        color="transparent"
                                    >
                                        Sign In
                                    </Button>
                                </ListItem>
                            </List>
                            <List sx={(theme) => getSxStyle(theme, headersStyle, ['list', 'mlAuto'])}>
                                <ListItem sx={(theme) => getSxStyle(theme, headersStyle, ['listItem'])}>
                                    <Button
                                        color="transparent"
                                        href="https://twitter.com/"
                                        target="_blank"
                                        sx={(theme) => getSxStyle(theme, headersStyle, ['navLink', 'navLinkJustIcon'])}
                                    >
                                        <i className={"fab fa-twitter"} />
                                    </Button>
                                </ListItem>
                                <ListItem sx={(theme) => getSxStyle(theme, headersStyle, ['listItem'])}>
                                    <Button
                                        color="transparent"
                                        href="https://www.facebook.com/"
                                        target="_blank"
                                        sx={(theme) => getSxStyle(theme, headersStyle, ['navLink', 'navLinkJustIcon'])}
                                    >
                                        <i className={"fab fa-facebook"} />
                                    </Button>
                                </ListItem>
                                <ListItem sx={(theme) => getSxStyle(theme, headersStyle, ['listItem'])}>
                                    <Button
                                        color="transparent"
                                        href="https://www.instagram.com/"
                                        target="_blank"
                                        sx={(theme) => getSxStyle(theme, headersStyle, ['navLink', 'navLinkJustIcon'])}
                                    >
                                        <i className={"fab fa-instagram"} />
                                    </Button>
                                </ListItem>
                            </List>
                        </Box>
                    }
                />
                {/*<div*/}
                {/*    className={classes.pageHeader}*/}
                {/*    style={{ backgroundImage: `url("${office2}")` }}*/}
                {/*>*/}
                {/*    <div className={classes.conatinerHeader2}>*/}
                {/*        <GridContainer>*/}
                {/*            <GridItem*/}
                {/*                xs={12}*/}
                {/*                sm={8}*/}
                {/*                md={8}*/}
                {/*                className={classNames(*/}
                {/*                    classes.mlAuto,*/}
                {/*                    classes.mrAuto,*/}
                {/*                    classes.textCenter*/}
                {/*                )}*/}
                {/*            >*/}
                {/*                <h1 className={classes.title}>Tvoj virtuelni asistent za održavanje vozila</h1>*/}
                {/*                <h4>*/}
                {/*                    Smart Part aplikacija ti omogućava da na jednostavan način bez muke pronađeš*/}
                {/*                    najpovoljnije delove za svoj automobil. Na tebi je samo da popuniš zahtev*/}
                {/*                    i da odabereš najpovoljniju ponudu. Aplikacija će sve ostalo uraditi za tebe.*/}
                {/*                </h4>*/}
                {/*            </GridItem>*/}
                {/*            /!*<GridItem*!/*/}
                {/*            /!*  xs={12}*!/*/}
                {/*            /!*  sm={10}*!/*/}
                {/*            /!*  md={10}*!/*/}
                {/*            /!*  className={classNames(classes.mlAuto, classes.mrAuto)}*!/*/}
                {/*            /!*>*!/*/}
                {/*            /!*  <Card raised className={classes.card}>*!/*/}
                {/*            /!*    <CardBody formHorizontal>*!/*/}
                {/*            /!*      <form>*!/*/}
                {/*            /!*        <GridContainer>*!/*/}
                {/*            /!*          <GridItem xs={12} sm={3} md={3}>*!/*/}
                {/*            /!*            <CustomInput*!/*/}
                {/*            /!*              id="name"*!/*/}
                {/*            /!*              inputProps={{*!/*/}
                {/*            /!*                placeholder: "Company name"*!/*/}
                {/*            /!*              }}*!/*/}
                {/*            /!*              formControlProps={{*!/*/}
                {/*            /!*                fullWidth: true,*!/*/}
                {/*            /!*                className: classes.formControl*!/*/}
                {/*            /!*              }}*!/*/}
                {/*            /!*            />*!/*/}
                {/*            /!*          </GridItem>*!/*/}
                {/*            /!*          <GridItem xs={12} sm={3} md={3}>*!/*/}
                {/*            /!*            <CustomInput*!/*/}
                {/*            /!*              id="email"*!/*/}
                {/*            /!*              inputProps={{*!/*/}
                {/*            /!*                placeholder: "Company email"*!/*/}
                {/*            /!*              }}*!/*/}
                {/*            /!*              formControlProps={{*!/*/}
                {/*            /!*                fullWidth: true,*!/*/}
                {/*            /!*                className: classes.formControl*!/*/}
                {/*            /!*              }}*!/*/}
                {/*            /!*            />*!/*/}
                {/*            /!*          </GridItem>*!/*/}
                {/*            /!*          <GridItem xs={12} sm={3} md={3}>*!/*/}
                {/*            /!*            <CustomInput*!/*/}
                {/*            /!*              id="password"*!/*/}
                {/*            /!*              inputProps={{*!/*/}
                {/*            /!*                placeholder: "Company password",*!/*/}
                {/*            /!*                type: "password",*!/*/}
                {/*            /!*                autoComplete: "off"*!/*/}
                {/*            /!*              }}*!/*/}
                {/*            /!*              formControlProps={{*!/*/}
                {/*            /!*                fullWidth: true,*!/*/}
                {/*            /!*                className: classes.formControl*!/*/}
                {/*            /!*              }}*!/*/}
                {/*            /!*            />*!/*/}
                {/*            /!*          </GridItem>*!/*/}
                {/*            /!*          <GridItem xs={12} sm={3} md={3}>*!/*/}
                {/*            /!*            <Button*!/*/}
                {/*            /!*              block*!/*/}
                {/*            /!*              color="primary"*!/*/}
                {/*            /!*              className={classes.button}*!/*/}
                {/*            /!*            >*!/*/}
                {/*            /!*              Sign up*!/*/}
                {/*            /!*            </Button>*!/*/}
                {/*            /!*          </GridItem>*!/*/}
                {/*            /!*        </GridContainer>*!/*/}
                {/*            /!*      </form>*!/*/}
                {/*            /!*    </CardBody>*!/*/}
                {/*            /!*  </Card>*!/*/}
                {/*            /!*</GridItem>*!/*/}
                {/*        </GridContainer>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            {/* HEADER 2 END */}

        </div>
    );
}
